import React, { useState } from 'react';
import { NavLink } from 'react-router-dom';
import './Navbar.css';

import acmLogo from '../assets/acm_w_logo.png';
import pceLogo from '../assets/pce_logo.png';

const Navbar = () => {
  // State to control the visibility of the dropdown
  const [isTeamDropdownVisible, setTeamDropdownVisible] = useState(false);

  // Handlers to show/hide the dropdown on hover
  const handleMouseEnter = () => {
    setTeamDropdownVisible(true);
  };

  const handleMouseLeave = () => {
    setTeamDropdownVisible(false);
  };

  return (
    <nav className="navbar">
      <div className="navbar-brand">
        <img src={acmLogo} alt="ACM Logo" className="navbar-logo" />
        <span className="navbar-title">PCE ACM-W</span>
      </div>

      <ul className="nav-links">
        <li><NavLink to="/" className="nav-item">Home</NavLink></li>
        <li><NavLink to="/about" className="nav-item">About</NavLink></li>
        <li><NavLink to="/events" className="nav-item">Events</NavLink></li>
        
        {/* Team item with dropdown functionality */}
        <li 
          className="nav-item-relative"
          onMouseEnter={handleMouseEnter} 
          onMouseLeave={handleMouseLeave}
        >
          {/* This is now a div, not a NavLink, so it is not clickable */}
          <div className="nav-item team-link-container">
            Team <span className="arrow-down">▼</span>
          </div>
          
          {/* Dropdown Menu */}
          {isTeamDropdownVisible && (
            <div className="dropdown-menu">
              <NavLink to="/team/core-team" className="dropdown-item">
                Core Team
              </NavLink>
              <NavLink to="/team/web-team" className="dropdown-item">
                Members
              </NavLink>
            </div>
          )}
        </li>

        <li><NavLink to="/gallery" className="nav-item">Gallery</NavLink></li>
        <li><NavLink to="/contact" className="nav-item">Contact Us</NavLink></li>
      </ul>

      <div className="navbar-right">
        <img src={pceLogo} alt="PCE Logo" className="navbar-logo" />
      </div>
    </nav>
  );
};

export default Navbar;
